import api from '@/services/api';
import Vue from 'vue';

const { $alertify } = Vue.prototype;

const PROGRAMAS_SEM_VALIDACAO = ['CEP999A1'];

const consultarPrograma = async (programa) => {
  if (PROGRAMAS_SEM_VALIDACAO.includes(programa.toUpperCase())) {
    return true;
  }

  const permiteAcesso = `api/validaAcessoPrg/${programa}`;
  try {
    await api.get(permiteAcesso);
    return true;
  } catch (error) {
    const doisUltimos = programa.slice(-2);
    const antePenultimo = doisUltimos.substr(0, 1);
    const ultimo = programa.slice(-1);
    if (ultimo != '1' && antePenultimo == 'A') {
      programa = `${programa.slice(0, -1)}1`;
      return consultarPrograma(programa);
    }
    if (antePenultimo != 'A') {
      programa = `${programa.slice(0, -2)}A1`;
      return consultarPrograma(programa);
    }
    return false;
  }
};

const openTab = async (programa, titulo, parametros = {}, rota = null) => {
  const data = {
    programa,
    titulo,
    parametros,
    rota,
  };
  const consulta = await consultarPrograma(programa.toUpperCase());
  if (!consulta) {
    $alertify.error(`Usuário não possui permissão - ( ${programa} - ${titulo} ).`);
  } else {
    window.parent.postMessage(data, '*');
  }
};

export default openTab;
